import Vue from 'vue'
import { VueHammer } from 'vue2-hammer'

// VueHammer.config.domEvents = true;

Vue.use(VueHammer)
